import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { API_MAP } from '../../../core/helpers/api.map';
import { TransparencyService } from './transparency.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const transparencyResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  return inject(TransparencyService)
    .get(API_MAP.transparency + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
